export const getLinkedAccountConditionPath = (
  linkedAccountId: string,
  linkedAccountConditionId?: string,
) =>
  `integrations/selective-sync/linked-account/${linkedAccountId}/linked-account-conditions${
    linkedAccountConditionId ? `/${linkedAccountConditionId}` : ""
  }`;
